import { FormEvent, Component } from 'react';
import track from 'react-tracking';
import Modal from '@components/Modal';
import { Textfield } from '@simplywallst/ui-core';
import { Container } from './styled';

interface EditAndSaveScreenerModalProps {
  title?: string;
  onClose: () => void;
  onConfirm: (viewName: string, description: string) => void;
  oldName?: string;
  oldDescription?: string;
  confirmLabel?: string;
  primaryLoading?: boolean;
  disabled?: boolean;
}
interface State {
  viewName: string;
  viewDescription: string;
  showViewNameError: boolean;
  modified: boolean;
}
class EditAndSaveScreenerModal extends Component<
  EditAndSaveScreenerModalProps,
  State
> {
  state = {
    viewName: '',
    viewDescription: '',
    showViewNameError: false,
    modified: false,
  };

  static defaultProps = {
    title: 'save',
    confirmLabel: 'OK',
  };
  /* Works with React 16.5 */
  static getDerivedStateFromProps(
    nextProps: EditAndSaveScreenerModalProps,
    prevState: State
  ): null | State {
    const { oldName, oldDescription } = nextProps;
    const { viewName, viewDescription, modified } = prevState;
    if (modified) {
      return {
        ...prevState,
        viewName,
        viewDescription,
      };
    }
    return {
      ...prevState,
      viewName: oldName ? `${oldName}` : '',
      viewDescription: oldDescription ? oldDescription : '',
    };
  }

  handleConfirm = () => {
    const { onConfirm } = this.props;
    const { viewName } = this.state;
    this.setState(
      () => ({
        showViewNameError: viewName.length === 0,
      }),
      () => {
        const { showViewNameError, viewName, viewDescription } = this.state;
        if (!showViewNameError) {
          onConfirm(viewName, viewDescription);
        }
      }
    );
  };
  render() {
    const { onClose, title, confirmLabel, primaryLoading, disabled } =
      this.props;

    return (
      <Modal
        title={title}
        onSecondaryClick={onClose}
        onPrimaryClick={this.handleConfirm}
        primaryLabel={confirmLabel}
        primaryLoading={primaryLoading}
        disabled={disabled}
      >
        <Container>
          <Textfield
            name="viewName"
            styleType="standardReverse"
            type="text"
            label="Name"
            placeholder="e.g. High Growth Stocks"
            value={this.state.viewName}
            onChange={(evt: FormEvent<HTMLInputElement>) =>
              this.setState({
                modified: true,
                viewName: evt.currentTarget.value,
                showViewNameError: evt.currentTarget.value.length === 0,
              })
            }
            error={this.state.showViewNameError ? 'Name cannot be blank' : ''}
          />
          <Textfield
            name="viewDescription"
            styleType="standardReverse"
            type="text"
            label="Description (optional)"
            placeholder="Describe your screener"
            value={this.state.viewDescription}
            onChange={(evt: FormEvent<HTMLInputElement>) =>
              this.setState({
                modified: true,
                viewDescription: evt.currentTarget.value,
              })
            }
          />
        </Container>
      </Modal>
    );
  }
}
export default track({
  type: 'track',
  subject: 'EditAndSaveScreenerModal',
})(EditAndSaveScreenerModal);
